module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self"
  }, [_c('router-link', {
    staticClass: "home-link",
    attrs: {
      "to": "/"
    }
  }), _c('span', {
    staticClass: "title"
  }, [_vm._v("Créer")]), _c('router-link', {
    staticClass: "close-link",
    attrs: {
      "to": "/"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63f17be5!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/create/CreateHeaderBar.vue
// module id = 596
// module chunks = 2